module.exports = __webpack_public_path__ + "img/clear-day.1cbef1c7.svg";